import { checkStatus, fetchCompressedData, returnJson } from '@/helpers/api'
import Vue from 'vue'
import { Bugfender } from '@bugfender/sdk'

/**
 * Declare Variable
 */
const state = {
  locationData: [],
  selectedLocation: null,
}

const getters = {
  getSelectedLocationData: (state) => state.locationData.find(location => location.locationUuid === state.selectedLocation),
  getFilteredLocationUuids: (state) => ({ key, unit, from, to }) => {
    if (unit?.trim() === '%') {
      from = from / 100
      to = to / 100
    }

    // todo:: aggregation of data should happen in the backend for performance reasons.
    return state.locationData
      .filter(report => report.data.metrics[key] >= from && report.data.metrics[key] <= to)
      .map(report => report.data.charge_point_id)
  },
}

const actions = {
  async fetchConnectionPointsByUuid({ commit }, { uuid, code }) {
    const token = await this.$auth.getTokenSilently()

    return await fetch(`${process.env.VUE_APP_MONITORING_API_URL}/location`, {
      method: 'POST',
      headers: {
        authorization: 'Bearer ' + token,
        'X-From': 'maps',
      },
      body: JSON.stringify({ uuid, code }),
    })
      .then(await checkStatus)
      .then(returnJson)
      .then(response => {
        if (!response.data) {
          return
        }

        response.data.forEach(data => commit('upsertLocationData', { data }))
      })
      .catch((e) => {
        Bugfender.error('fetchConnectionPointsByUuid: ', e)

        Vue.notify({
          type: 'error',
          title: 'Er is iets misgegaan!',
          text: 'Monitoring data kon niet worden opgehaald',
        })
      })
  },
  async fetchAllUsageReports({ commit }, { code }) {
    const allData = []
    const limit = 400
    let hasNextPage = false
    let page = 1

    try {
      const token = await this.$auth.getTokenSilently()

      do {
        const response = await fetchCompressedData('/api/reports-overview-by-code', {
          method: 'POST',
          headers: {
            authorization: 'Bearer ' + token,
          },
          body: JSON.stringify({ code, page, limit }),
        })

        const data = response.data || []

        if (data.length < limit || !data) {
          hasNextPage = false
        } else {
          hasNextPage = true
        }

        allData.push(...data)
        page++
      } while (hasNextPage)

      if (allData.length > 0) {
        commit('setLocationData', { data: allData })

        Vue.notify({
          type: 'success',
          title: 'Klaar!',
          text: 'Monitoring data is opgehaald',
        })
      } else {
        Vue.notify({
          type: 'warn',
          title: 'Geen data',
          text: 'Monitoring data niet beschikbaar.',
        })
      }
    } catch (e) {
      hasNextPage = false
      if (e.message !== 'Access denied') {
        Vue.notify({
          type: 'error',
          title: 'Er is iets misgegaan!',
          text: 'Monitoring data kon niet worden opgehaald',
        })
      }
      Bugfender.error('fetchAllUsageReports: ', e)
    }
  },
  selectLocation({ commit }, { location }) {
    commit('setSelectedLocation', { location })
  },
  deselectLocation({ commit }) {
    commit('setSelectedLocation', { location: null })
  },
}

const mutations = {
  upsertLocationData: function (state, { data }) {
    let index = state.locationData.findIndex(stateLocationData => data.locationUuid === stateLocationData.locationUuid)
    if (index === -1) {
      state.locationData.push(data)
      return
    }

    state.locationData[index] = data
  },
  setLocationData: function (state, { data }) {
    state.locationData = data
  },
  setSelectedLocation(state, { location }) {
    state.selectedLocation = location
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
